import React, { Component, createRef, RefObject } from "react";
import { Subscription, BehaviorSubject } from "rxjs";
import { debounceTime, distinctUntilChanged, filter } from "rxjs/operators";

type RxProps = {
	value?: string;
	onChange: (input: string) => void;
	debounce?: number;
	minLength?: number;
	inputProps?: {};
};
type RxState = {
	value: string;
};
export default class RxInput extends Component<RxProps, RxState> {
	subscription = null as Subscription;
	subject$: BehaviorSubject<string>;
	input = null as RefObject<HTMLInputElement>;

	constructor(props: RxProps) {
		super(props);

		this.state = {
			value: null || this.props.value,
		};
		this.subject$ = new BehaviorSubject("");
		this.input = createRef<HTMLInputElement>();
	}

	static getDerivedStateFromProps(nextProps: RxProps, prevState: RxState) {
		if (prevState.value === null) {
			return { value: nextProps.value };
		}

		return null;
	}

	componentDidMount() {
		const { debounce, minLength, onChange } = this.props;

		this.subscription = this.subject$
			.pipe(
				filter((v: string) => v.length >= minLength),
				debounceTime(debounce),
				distinctUntilChanged()
			)
			.subscribe(onChange);
	}

	componentWillUnmount() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}

	setValue = (value: string) => {
		this.setState({ value });
	};

	focus = () => {
		this.input.current.focus();
	};

	clear = () => {
		this.setValue("");
	};

	handleChange = ({ target }: { target: HTMLInputElement }) => {
		const value = target.value;

		this.setState({ value }, () => {
			if (value.length < this.props.minLength) {
				this.props.onChange("");
			} else {
				this.subject$.next(value);
			}
		});
	};

	render() {
		return (
			<input
				{...this.props.inputProps}
				type="text"
				onChange={this.handleChange}
				value={this.state.value}
				ref={this.input}
			/>
		);
	}
}
